import { getFileName } from "@helpers/getFileName"
import { useQuery } from "@tanstack/react-query"
import { requestApi2 } from "@utils/http"
import { endpoints, UserInfo } from "api"

type SeempGetUsersQueryArgs = {
	companyName: string | undefined
}

export const getUseSeempGetUsersqueryKey = (companyName: string | undefined, source?: string) => {
	return [
		`source=${source ?? getFileName()}`,
		`queryId=SeempGetUsers`,
		`endpoints=[${endpoints.seempGetCompanyUsers.getName()}]`,
		`companyName=${companyName}`,
	]
}

export function useSeempGetUsersQuery(args: SeempGetUsersQueryArgs) {
	const enabled = args.companyName !== undefined

	const res = useQuery({
		queryKey: getUseSeempGetUsersqueryKey(args.companyName, getFileName()),
		queryFn: async (): Promise<UserInfo[] | null> => {
			if (args.companyName === undefined) {
				throw new Error("useSeempGetUsersQuery requires a companyName parameter")
			}
			const usersInfo = await requestApi2(endpoints.seempGetCompanyUsers, {
				companyName: args.companyName,
			})
			return usersInfo === null
				? usersInfo
				: usersInfo.sort((a, b) => a.name.localeCompare(b.name))
		},
		enabled,
		staleTime: 600000,
		refetchInterval: 600000,
	})
	return res
}
